import React, { useState, useRef, useEffect } from 'react';
import { formatFieldName, formatValue, getBadgeColor } from '../../utils/formatters';

const AnswersSection = ({ standardAnswers, reasons }) => {
    const [hoveredField, setHoveredField] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, right: 0 });
    const iconRefs = useRef({});

    useEffect(() => {
        if (hoveredField && iconRefs.current[hoveredField]) {
            const iconElement = iconRefs.current[hoveredField];
            const rect = iconElement.getBoundingClientRect();
            setTooltipPosition({
                top: rect.top - 8, // 8px margin above icon
                right: window.innerWidth - rect.right
            });
        }
    }, [hoveredField]);

    if (standardAnswers.length === 0) {
        return null;
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Answers</h4>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '15px'
            }}>
                {standardAnswers.map(([field, value]) => {
                    const hasReason = reasons && reasons[field];
                    const reason = hasReason ? reasons[field] : '';
                    const isHovered = hoveredField === field;
                    return (
                        <div 
                            key={field}
                            style={{
                                backgroundColor: '#2d2d2d',
                                border: '1px solid #404040',
                                borderRadius: '6px',
                                padding: '15px',
                                position: 'relative'
                            }}
                        >
                            <div style={{ 
                                fontSize: '12px',
                                color: '#a0a0a0',
                                textTransform: 'uppercase',
                                marginBottom: '8px',
                                fontWeight: '600',
                                letterSpacing: '0.5px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}>
                                <span>{formatFieldName(field)}</span>
                                {hasReason && (
                                    <div 
                                        style={{ position: 'relative', display: 'inline-block' }}
                                        onMouseEnter={() => setHoveredField(field)}
                                        onMouseLeave={() => setHoveredField(null)}
                                    >
                                        <i 
                                            ref={el => iconRefs.current[field] = el}
                                            className="bi bi-info-circle"
                                            style={{
                                                color: isHovered ? '#90caf9' : '#64b5f6',
                                                cursor: 'pointer',
                                                fontSize: '16px',
                                                transition: 'all 0.2s ease',
                                                display: 'inline-block',
                                                transform: isHovered ? 'scale(1.1)' : 'scale(1)'
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                <span style={{
                                    display: 'inline-block',
                                    backgroundColor: getBadgeColor(field, value),
                                    color: '#fff',
                                    padding: '4px 12px',
                                    borderRadius: '12px',
                                    fontSize: '14px'
                                }}>
                                    {formatValue(value)}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
            {hoveredField && reasons && reasons[hoveredField] && (
                <div
                    style={{
                        position: 'fixed',
                        top: `${tooltipPosition.top}px`,
                        right: `${tooltipPosition.right}px`,
                        transform: 'translateY(-100%)',
                        marginBottom: '8px',
                        padding: '12px 16px',
                        backgroundColor: '#1a1a1a',
                        color: '#d0d0d0',
                        borderRadius: '8px',
                        fontSize: '13px',
                        lineHeight: '1.6',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        maxWidth: '400px',
                        width: 'max-content',
                        maxHeight: '300px',
                        overflow: 'auto',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
                        border: '1px solid rgba(100, 181, 246, 0.3)',
                        zIndex: 9999,
                        animation: 'fadeIn 0.2s ease',
                        pointerEvents: 'none'
                    }}
                >
                    <div style={{
                        fontWeight: '600',
                        color: '#e0e0e0',
                        marginBottom: '8px',
                        fontSize: '12px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                    }}>
                        Model Reasoning
                    </div>
                    {reasons[hoveredField]}
                </div>
            )}
            <style>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(calc(-100% - 4px));
                    }
                    to {
                        opacity: 1;
                        transform: translateY(-100%);
                    }
                }
            `}</style>
        </div>
    );
};

export default AnswersSection;


